<div wnlGroup #wnlGroup="wnlGroup">
  <div class="wnl-header">
    @if (patient().isPediatric()) {
      <p>
        WNL: No constipation, diarrhea or nausea. BM brown and formed. BS present and active. Full bowel
        control. Abdomen not tender to palpation. Tolerating meals well. Umbilical cord clean and dry (if applicable).
      </p>
    } @else {
      <p>
        WNL: No constipation, diarrhea or nausea. BM brown and formed. BS present and active. Full bowel
        control. Abdomen not tender to palpation. Tolerating meals well.
      </p>
    }

    <mat-checkbox [checked]="wnlGroup.allWnl" [indeterminate]="wnlGroup.someWnl"
      (change)="wnlGroup.setAllWnl($event.checked)"
      [ngClass]="{'wnl-checked': wnlGroup.allWnl && !wnlGroup.someWnl, 'wnl-indeterminate': wnlGroup.someWnl}">
      All Within Normal Limits
    </mat-checkbox>
  </div>

  <div [formGroup]="formGroup()" class="form-container">
  <h2>Bowel Sounds</h2>
  <div class="bowel-sounds">
    <emr-input type="select" label="LUQ" [control]="formGroup().controls.bowelSoundsLuq" [options]="bowelSoundsOptions"
      [wnlControl]="'luq'" [wnlDefault]="'WNL'" [bottomSpace]="true" />

    <emr-input type="select" label="RUQ" [control]="formGroup().controls.bowelSoundsRuq" [options]="bowelSoundsOptions"
      [wnlControl]="'ruq'" [wnlDefault]="'WNL'" [bottomSpace]="true" />

    <emr-input type="select" label="LLQ" [control]="formGroup().controls.bowelSoundsLlq" [options]="bowelSoundsOptions"
      [wnlControl]="'llq'" [wnlDefault]="'WNL'" [bottomSpace]="true" />

    <emr-input type="select" label="RLQ" [control]="formGroup().controls.bowelSoundsRlq" [options]="bowelSoundsOptions"
      [wnlControl]="'rlq'" [wnlDefault]="'WNL'" [bottomSpace]="true" />
  </div>

  <div class="other">
    <assessment-row title="Abnormal Bowel Movement">
      <emr-input class="assessment-input" type="text" [control]="formGroup().controls.abnormalBowelMovement"
        [wnlControl]="'abnormalBowelMovement'" [wnlDefault]="''" />
    </assessment-row>

    <assessment-row title="Nausea">
      <emr-checkbox [control]="formGroup().controls.nausea" label="Yes" [wnlControl]="'nausea'"
        [wnlDefault]="false" />
    </assessment-row>

    <assessment-row title="Emesis">
      <emr-input type="select" [control]="formGroup().controls.emesis" [options]="emesisOptions"
        [wnlControl]="'emesis'" [wnlDefault]="'WNL'" />
    </assessment-row>

    <assessment-row title="Bowel Control">
      <emr-checkbox [control]="formGroup().controls.incontinence" label="Incontinence" [wnlControl]="'incontinence'"
        [wnlDefault]="false" />
    </assessment-row>

    <h2>Ostomy</h2>
    <div class="ostomy">
      <assessment-row title="Stoma Site">
        <emr-input type="select" [control]="formGroup().controls.ostomyStomaSite" [options]="stomaSiteOptions"
          [wnlControl]="'stomaSite'" [wnlDefault]="'None'" />
      </assessment-row>

      <assessment-row title="Output">
        <emr-input type="select" [control]="formGroup().controls.ostomyOutput" [options]="outputOptions"
          [wnlControl]="'output'" [wnlDefault]="'Formed'" />
      </assessment-row>
    </div>

    <h2>Hemorrhoids</h2>
    <assessment-row title="Hemorrhoids">
      <emr-checkbox [control]="formGroup().controls.hemorrhoids" label="Present" [wnlControl]="'hemorrhoids'"
        [wnlDefault]="false" />
    </assessment-row>

    <h2>Nutrition</h2>

    <assessment-row title="Reduced Appetite">
      <emr-checkbox [control]="formGroup().controls.reducedAppetite" label="Yes" [wnlControl]="'reducedAppetite'"
        [wnlDefault]="false"></emr-checkbox>
    </assessment-row>

    <assessment-row title="Unplanned Weight loss in past 3-6 months">
      <emr-input type="select" [control]="formGroup().controls.weightLossPercentage" [options]="weightLossOptions"
        [bottomSpace]="true" width="5" [wnlControl]="'weightLossPercentage'" [wnlDefault]="'< 5%'" />
    </assessment-row>

    <assessment-row title="Nutrition Score" description="Sum of all points per category">
      <div [wnlControl]="'nutritionRisk'" [wnlFormControl]="formGroup().controls.nutritionScore"
        [wnlIsWnl]="nutritionRiskIsWnl" [wnlApplyStrategy]="'keep'" [wnlClearStrategy]="'keep'"></div>
      <h3 class="fr-score">{{ nutritionRiskCategory }}</h3>
    </assessment-row>

    <assessment-row title="Oral Diet">
      <emr-input type="select" [control]="formGroup().controls.oralDiet" [options]="oralDietOptions"
        [bottomSpace]="true" [wnlControl]="'oralDiet'" [wnlDefault]="'Independent'" />
    </assessment-row>

    <assessment-row title="Tube Feed">
      <emr-checkbox [control]="formGroup().controls.tubeFeed" label="Yes" [wnlControl]="'tubeFeed'"
        [wnlDefault]="false" />
    </assessment-row>
    @if (formGroup().controls.tubeFeed.value) {
      <assessment-row title="Tube Type">
        <emr-input type="text" [control]="formGroup().controls.tubeType" />
      </assessment-row>

      <assessment-row title="How many hours since bag change?">
        <emr-input type="text" [control]="formGroup().controls.bagChangedHours" />
      </assessment-row>

      <assessment-row title="Site Assessment">
        <emr-input type="text" [control]="formGroup().controls.siteAssessment" />
      </assessment-row>
    }

    @if (patient().isPediatric()) {
      <assessment-row title="Abnormal Umbilical Cord">
        <emr-checkbox [control]="formGroup().controls.abnormalUmbilicalCord" label="Yes"
          [wnlControl]="'abnormalUmbilicalCord'" [wnlDefault]="false" />
      </assessment-row>
      @if (formGroup().controls.abnormalUmbilicalCord.value) {
        <assessment-row title="Describe Abnormality">
          <emr-input type="text" [control]="formGroup().controls.umbilicalCordDetails" />
        </assessment-row>
      }
    }

    <assessment-row title="Other Findings">
      <emr-input type="text" [control]="formGroup().controls.otherFindings" [wnlControl]="'otherFindings'"
        [wnlDefault]="''" />
    </assessment-row>
  </div>
</div>
</div>